module.exports = __webpack_public_path__ + "img/ig.0c662d61.svg";